<template>
  <div>
    <van-nav-bar placeholder title="机构" >
    </van-nav-bar>

    <div class="top-search clearfiex">
      <van-search
          v-model="queryParams.name"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
      >
        <template #action>
          <button @click="onSearch" class="search-but">搜索</button>
        </template>
      </van-search>
    </div>
    <!--下拉刷新-->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">

      <!--分页列表-->
      <van-list
          class="my-list"
          v-model="data.bottomLoading"
          :finished="!data.hasMore"
          finished-text="没有更多了"
          @load="bottomRefresh()"
      >
        <div class="mykc-box" v-for="(item,index) in  data.records" :key="index" @click="showDialog(item)">
          <div class="jg-list-top"  @click="getUnpaid(item)">
            <img v-if="item.pic" :src="fileDisplayPrefix +  (item.pic || '').split(',')[0]"/>
            <img v-else src="@/assets/patternless.png">
            <div class="jg-right">
              <h2><a href="#">{{item.name}}</a></h2>
              <span class="time">地址：{{item.address}}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>

import {handlePageData} from "../../utils/common";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import {getOrganizeList} from "../../api/organization/organization";
import {Dialog} from "vant";
import {addUserGgreementRecord, getAgreement} from "../../api/courseSelection/courseSelection";

export default {
  name: 'service',
  components: {},
  data() {
    return {
      fileDisplayPrefix:FILE_DISPLAY_PREFIX,
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      queryParams: {},
    }
  },
  computed: {},
  created() {
    this.refresh()
  },
  mounted() {
  },
  methods: {
    showDialog(item){

      if (item.agreement){
        this.$router.push({path: `/organization/detail?id=${item.id}`})
      }else {

        getAgreement(item.id).then(res => {
          if (res.code === 10000) {
            const data = res.result || {}
            Dialog.confirm({
              title: data.title,
              message: data.content,
            })
                .then(() => {
                  addUserGgreementRecord({institutionId:item.id}).then(e =>{
                    if (e.code === 10000){
                      this.$router.push({path: `/organization/detail?id=${item.id}`})
                    }
                  })
                })
                .catch(() => {
                  // on cancel
                });
          }
        })

      }




    },
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size
      getOrganizeList(this.queryParams).then(res => {
        if (res.code === 10000) {
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    },
    onSearch() {
        this.refresh()
    },

    refresh() {
      this.reset();
      this.getList();
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },

    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    getScore(res){
      this.$router.push({path: `/course/score?id=${res.id}`})
    },

    getUnpaid(res){
      if ('0' ===res.status || '9' ===res.status){
        this.$router.push({path: `/course/unpaid?id=${res.id}`})
      }else if('1' === res.status){
        this.$router.push({path: `/course/reading` , query: {id: res.id}})
      }else if ('2' === res.status || '3' === res.status){
        this.$router.push({path: `/course/auditDetail?id=${res.id}`})
      }


    }
  }
}
</script>

<style scoped>
.c-class{
  height:35px;
  border-radius:25px 25px 0  0;
  background: #FFFFFF;
  position: relative;
  top: -25px;
}
.top-search{
  display: flex;
  height:103px;
  background: url("~@/assets/itop.png") left center;
  background-size: 100% 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
}
/*.top-search::after{
  display: flex;
  width: 100%;
  height:28px;
  background: #FFFFFF;
  border-radius:25px 25px 0  0;
}*/
/deep/.van-tabs__nav{
  background:none;
  display: flex;
  align-items: center;
}
/deep/.van-search{
  display: flex;
  width: 100%;
  padding: 0 10px;
  background: none;
  justify-content: space-between;
  position: relative;
  top: -12px;
}
/deep/.van-search__content{
  height:28px;
  background: rgba(249,248,248,0.7);
  border-radius:100px;
  display: flex;
  justify-content: space-between;
}
/deep/.van-search .van-cell{
  padding: 0;
  display: flex;
  align-items: center;
}
/deep/.van-cell{
}
.search-but {
  display: flex;
  padding:0 3px;
  background: #66C779;
  border-radius: 25px;
  width:56px;
  height:28px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size:12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}
/deep/.van-search__action{
  margin:0;
  padding: 0;
  margin-left:5px;
}
.my-list{
  background: #f2f6fd;
  padding:10px;
}
.mykc-box{
  /*height:108px;*/
  background: #ffffff;
  border-radius:12px;
  margin-bottom: 10px;
}
.jg-right span{
  width: 100%;
  justify-content: space-between;
}
.jg-right span i{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  padding:5px 6px;
  border-radius:12px;
  position: absolute;
  top: -5px;
  right: 0;
  min-width: 50px;
}
.jg-right span i.t0{
  background: #FF9900;
}
.jg-right span i.t1{
  background: #66C779;
}
.jg-right span i.t2{
  background: #66C779;
}
.jg-right span i.t3{
  background: #A37FFF;
}
.jg-right span i.t4{
  background: #A7A7A7;
}
.jg-right span i.t5{
  background: #A7A7A7;
}
.jg-bottom i.jg-but{
  margin-bottom: 10px;
}
</style>
